export default "__VITE_ASSET__g2PqGwy7__"